(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href="#buy"]');
    if (!a) return;
    var t = document.getElementById('buy') || document.querySelector('[data-rip-buybox]');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  function marquee(track) {
    if (reduce) return;
    var speed = parseFloat(track.getAttribute('data-speed') || '4');
    var count = parseInt(track.getAttribute('data-count') || '5', 10);
    var kids = track.children;
    if (kids.length < count * 2) return;
    var paused = false, last = null, raf = 0;

    function setWidth() {
      var first = kids[0], dupe = track.querySelector('[data-rip-dupe]');
      if (!dupe) return 0;
      return dupe.offsetLeft - first.offsetLeft;
    }
    function step(ts) {
      if (last === null) last = ts;
      var dt = (ts - last) / 1000; last = ts;
      if (!paused) {
        var card = kids[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        var pxs = (card + gap) / Math.max(speed, .5);
        track.scrollLeft += pxs * dt;
        var w = setWidth();
        if (w > 0 && track.scrollLeft >= w) track.scrollLeft -= w;
      }
      raf = requestAnimationFrame(step);
    }
    raf = requestAnimationFrame(step);

    function off() { paused = true; }
    function on() { paused = false; last = null; }
    function delayed(ms) { return function () { setTimeout(on, ms); }; }
    ['mouseenter', 'focusin', 'pointerdown', 'touchstart'].forEach(function (ev) {
      track.addEventListener(ev, off, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (ev) { track.addEventListener(ev, on, { passive: true }); });
    track.addEventListener('touchend', delayed(800), { passive: true });
    track.addEventListener('pointerup', delayed(600), { passive: true });
    track.addEventListener('wheel', function () { off(); delayed(600)(); }, { passive: true });
  }

  function carousel(root) {
    var track = root.querySelector('[data-rip-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rip-dot]'));
    if (!track) return;
    var timer = null, idx = 0, tweening = false;

    function cardStep() {
      var a = track.children[0], b = track.children[1];
      if (!a) return 0;
      return b ? (b.offsetLeft - a.offsetLeft) : a.getBoundingClientRect().width;
    }
    function maxIdx() {
      var step = cardStep();
      if (!step) return 0;
      return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step));
    }
    function mark(i) {
      dots.forEach(function (d, n) {
        if (n === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }
    function goTo(i, animate) {
      var m = maxIdx();
      idx = i > m ? 0 : (i < 0 ? m : i);
      var to = idx * cardStep();
      mark(Math.min(idx, dots.length - 1));
      if (reduce || animate === false) { track.scrollLeft = to; return; }
      var from = track.scrollLeft, t0 = performance.now(), dur = 250;
      var snap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      tweening = true;
      (function tick(now) {
        var p = Math.min(1, (now - t0) / dur);
        var e = p < .5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
        track.scrollLeft = from + (to - from) * e;
        if (p < 1) requestAnimationFrame(tick);
        else { track.style.scrollSnapType = snap; tweening = false; }
      })(t0);
    }
    function start() { stop(); timer = setInterval(function () { goTo(idx + 1); }, 3000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { goTo(n); start(); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(idx + 1); start(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(idx - 1); start(); }
    });
    var throttled = false;
    track.addEventListener('scroll', function () {
      if (tweening || throttled) return;
      throttled = true;
      setTimeout(function () {
        throttled = false;
        var step = cardStep();
        if (step) { idx = Math.round(track.scrollLeft / step); mark(Math.min(idx, dots.length - 1)); }
      }, 100);
    }, { passive: true });
    ['mouseenter', 'focusin', 'pointerdown'].forEach(function (ev) { track.addEventListener(ev, stop, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { track.addEventListener(ev, start, { passive: true }); });
    track.addEventListener('pointerup', function () { setTimeout(start, 600); }, { passive: true });
    mark(0);
    start();
  }

  function gallery(root) {
    var main = root.querySelector('[data-rip-main]');
    var swipe = root.querySelector('[data-rip-swipe]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-rip-thumb]'));
    if (!thumbs.length) return;

    function activate(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var src = thumbs[i].getAttribute('data-rip-src');
      if (main && src) { main.removeAttribute('srcset'); main.setAttribute('src', src); }
      if (main && !src) {
        var slot = thumbs[i].getAttribute('data-rip-slot');
        if (slot) main.setAttribute('data-slot-active', slot);
      }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        activate(i);
        if (swipe) swipe.scrollTo({ left: i * swipe.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if (swipe) {
      var ticking = false;
      swipe.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = swipe.clientWidth || 1;
          var i = Math.max(0, Math.min(thumbs.length - 1, Math.round(swipe.scrollLeft / w)));
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        });
      }, { passive: true });
    }
  }

  function modal(box) {
    var dlg = document.getElementById(box.getAttribute('data-rip-modal-id'));
    if (!dlg) return;
    var opener = box.querySelector('[data-rip-modal-open]');
    var lastFocused = null;

    function focusables() {
      return Array.prototype.slice.call(dlg.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      lastFocused = document.activeElement;
      dlg.hidden = false;
      requestAnimationFrame(function () { dlg.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var close = dlg.querySelector('[data-rip-modal-close-btn]');
      if (close) close.focus();
    }
    function close() {
      dlg.classList.remove('is-open');
      dlg.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }
    if (opener) opener.addEventListener('click', open);
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-rip-modal-close]'), function (el) {
      el.addEventListener('click', close);
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function sticky(bar) {
    var at = parseInt(bar.getAttribute('data-rip-sticky-at') || '400', 10);
    var visible = null, ticking = false;
    function update() {
      var want = window.scrollY > at;
      if (want === visible) return;
      visible = want;
      bar.classList.toggle('is-visible', want);
      bar.setAttribute('aria-hidden', want ? 'false' : 'true');
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    bar.removeAttribute('hidden');
    update();
  }

  function announce(bar) {
    var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-rip-ann-slide]'));
    if (slides.length < 2) return;
    bar.classList.remove('rip-ann--nojs');
    var speed = (parseFloat(bar.getAttribute('data-rip-ann-speed') || '4') || 4) * 1000;
    var i = 0;
    slides.forEach(function (s, n) { s.classList.toggle('is-on', n === 0); });
    if (reduce) return;
    setInterval(function () {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, speed);
  }

  ready(function () {
    document.querySelectorAll('[data-rip-marquee]').forEach(marquee);
    document.querySelectorAll('[data-rip-carousel]').forEach(carousel);
    document.querySelectorAll('[data-rip-gallery]').forEach(gallery);
    document.querySelectorAll('[data-rip-modal-id]').forEach(modal);
    document.querySelectorAll('[data-rip-sticky]').forEach(sticky);
    document.querySelectorAll('[data-rip-ann]').forEach(announce);
  });
})();
